import { getCustomerWalletDetails, getPointsBalance } from "api";
import {
  CustomerWalletStatus,
  ICustomerWalletDetailsResponse,
  ILoggedCustomer
} from "api/types";
import { ApolloClient } from "apollo-boost";
import { useAppState } from "AppState";
import Container from "components/common/Grid/Container";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import Text from "components/common/Text/Text";
import { CustomerDataContext } from "components/Gates/CustomerDataGate";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import * as React from "react";
import { ApolloConsumer } from "react-apollo";
import styled from "styled-components";
import MainDashboardMenu from "./MainDashboardMenu/MainDashboardMenu";

interface IState {
  customerPoints?: number;
  tenantId: string;
  blockchainWalletDetails: ICustomerWalletDetailsResponse;
}

interface IProps {
  hasNoInterests?: boolean;
  showTabletPurchaseFlow: boolean;
  showTabletRewardsFlow: boolean;
  showTabletPromoCodesFlow: boolean;
  client: ApolloClient<any>;
  loggedCustomer: ILoggedCustomer;
  location?: string;
  pointsBalance?: number;
  setPointsBalance?(pointsBalance: number): void;
}

const MainWrapper = ({ ...props }: IProps): JSX.Element => {
  const { locationName, setPointsBalance, pointsBalance } = useAppState();
  return (
    <Main
      {...props}
      location={locationName}
      setPointsBalance={setPointsBalance}
      pointsBalance={pointsBalance}
    />
  );
};

const Wrapper = styled.div`
  width: 95%;
`;

class Main extends React.Component<{} & IProps, IState> {
  constructor(props: {} & IProps) {
    super(props);
    this.state = {
      customerPoints: this.props.pointsBalance || 0,
      tenantId: "",
      blockchainWalletDetails: {
        walletStatus: CustomerWalletStatus.BlockchainDisabledForTenant,
        walletDetails: undefined
      }
    };
  }

  public async componentDidMount() {
    this.getPointsBalance();
    await this.loadCustomerWalletDetails();
  }

  public render() {
    const {
      hasNoInterests,
      showTabletPromoCodesFlow,
      showTabletRewardsFlow,
      showTabletPurchaseFlow,
      location
    } = this.props;
    const { tenantId, blockchainWalletDetails, customerPoints } = this.state;

    return (
      <PanelLayout
        title={location}
        titleSecondary="HOME"
        infoComponent={
          <Text h3 light center white noTransform>
            {customerPoints} pts
          </Text>
        }
        centerContent
      >
        <Wrapper>
          <MainDashboardMenu
            tenantId={tenantId}
            hasNoInterests={hasNoInterests}
            blockchainWalletDetails={blockchainWalletDetails}
            showTabletPurchaseFlow={showTabletPurchaseFlow}
            showTabletRewardsFlow={showTabletRewardsFlow}
            showTabletPromoCodesFlow={showTabletPromoCodesFlow}
          />
        </Wrapper>
      </PanelLayout>
    );
  }

  private getPointsBalance = async () => {
    try {
      const pointsBalance: number = await getPointsBalance(
        this.props.client,
        this.props.loggedCustomer ? this.props.loggedCustomer.authToken : ""
      );
      this.setState({ customerPoints: pointsBalance });
      if (this.props.setPointsBalance) {
        this.props.setPointsBalance(pointsBalance);
      }
    } catch (err) {
      console.error("couldn't get customer point balance", err);
    }
  };
  private loadCustomerWalletDetails = async () => {
    const { client, loggedCustomer } = this.props;
    const blockchainWalletDetails = await getCustomerWalletDetails(
      client,
      loggedCustomer.authToken
    );
    this.setState({ blockchainWalletDetails });
  };
}

export default () => (
  <ApolloConsumer>
    {client => (
      <TabletDataContext.Consumer>
        {tabletData =>
          tabletData && (
            <CustomerDataContext.Consumer>
              {loggedCustomer =>
                loggedCustomer && (
                  <MainWrapper
                    client={client}
                    loggedCustomer={loggedCustomer}
                    hasNoInterests={tabletData.hasNoInterests}
                    showTabletPurchaseFlow={
                      tabletData.locationSettings.showTabletPurchaseFlow
                    }
                    showTabletRewardsFlow={
                      tabletData.locationSettings.showTabletRewardsFlow
                    }
                    showTabletPromoCodesFlow={
                      tabletData.locationSettings.showTabletPromoCodesFlow
                    }
                  />
                )
              }
            </CustomerDataContext.Consumer>
          )
        }
      </TabletDataContext.Consumer>
    )}
  </ApolloConsumer>
);



// WEBPACK FOOTER //
// ./src/screens/Main/MainDashboard.tsx